import React, { memo, useState, useCallback } from "react"
import { Tabs } from "antd"
import { deleteTag } from "src/services"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import ApolloClient from "apollo-client"
import Modal from "src/dashboards/components/modalComponent"
import message from "antd/lib/message"
import "antd/lib/message/style/css"
import "./style.scss"

const { TabPane } = Tabs

export type ListType = {
  name: string
  content?: string | undefined
  key: string
  id?: string
}
interface props {
  tabsList: ListType[]
  handleTabChange: (tabSelection: string) => void
  children: React.ReactNode
  defaultKey?: any
  isCrossActive?: boolean
  client?: ApolloClient<NormalizedCacheObject>
  updateOptions?: (list: ListType[]) => void
}

const TabBar = ({
  tabsList,
  handleTabChange,
  children,
  defaultKey,
  isCrossActive = false,
  client,
  updateOptions
}: props) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const [selectValue, setSelectValue] = useState<string | unknown>("")

  const handleChangeTab = (selectedTab: string) => {
    handleTabChange(selectedTab)
  }

  const handleOk = useCallback(async () => {
    setLoading((prev: boolean) => !prev)
    const ids = tabsList.find(item => item?.name === selectValue)?.id
    const resp = await deleteTag(client, ids)
    if (resp && resp?.data?.deleteTag) {
      message.success("Tag deleted successfully!")
      setVisible((prev: boolean) => !prev)
      const updatedOptionsList = tabsList?.filter(options => options.name !== selectValue)
      if (updateOptions) updateOptions(updatedOptionsList || [])
    } else message.error(resp.toString())
    setLoading((prev: boolean) => !prev)
  }, [selectValue])

  const onClose = (): void => setVisible((prev: boolean) => !prev)

  const onDelete = (value: unknown) => {
    setSelectValue(value)
    setVisible((prev: boolean) => !prev)
  }

  return (
    <div id="tab-container">
      {!isCrossActive ? (
        <Tabs defaultActiveKey={defaultKey || "0"} onChange={handleChangeTab}>
          {tabsList.map((list, index) => (
            <TabPane tab={list.name} key={list.key}>
              {children}
            </TabPane>
          ))}
        </Tabs>
      ) : (
        <Tabs
          defaultActiveKey={defaultKey || "0"}
          onEdit={onDelete}
          onChange={handleChangeTab}
          type="editable-card"
        >
          {tabsList.map((list, index) => (
            <TabPane tab={list.name} key={list.key}>
              {children}
            </TabPane>
          ))}
        </Tabs>
      )}
      <Modal
        isModalVisible={visible}
        disabled={loading}
        isSubmitting={loading}
        handleCancel={onClose}
        handleOk={handleOk}
        btnText={"Confirm"}
        title={""}
      >
        <h4 style={{ textAlign: "center", fontSize: 20 }}>
          Are you sure you want to delete this tag
        </h4>
      </Modal>
    </div>
  )
}
export default memo(TabBar)
